export default "__VITE_ASSET__CunKFF_J__"